/* SPOTEC Motion — konten muncul halus saat di-scroll (fade + naik sedikit, kartu berurutan).
   Ringan: IntersectionObserver + CSS transform/opacity (tidak memicu layout ulang). */
/* Kartu fitur: sisi belakang = foto detail teknologi (dari popup fitur) + "Lihat detail".
   Desktop: balik saat hover (CSS). HP: tiap kartu membalik sekali saat pertama terlihat. */
(() => {
  if (window.__spxFlip) return;
  window.__spxFlip = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const touch = window.matchMedia('(hover: none)');
  const PEEK_HOLD = 1800;   // ms kartu menampilkan foto sebelum kembali (HP)
  const PEEK_STEP = 180;    // ms jeda antar kartu dalam satu baris (HP)
  const PLUS = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M6 1.5v9M1.5 6h9"/></svg>';

  const peekIO = ('IntersectionObserver' in window) ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const btn = entry.target;
      peekIO.unobserve(btn);
      const col = [...btn.closest('.sf-tech-grid')?.children || []].indexOf(btn.closest('.sf-tech-grid > *'));
      const delay = 250 + Math.max(0, col % 2) * PEEK_STEP;
      setTimeout(() => {
        btn.classList.add('is-peek');
        setTimeout(() => btn.classList.remove('is-peek'), PEEK_HOLD + 500);
      }, delay);
    });
  }, { threshold: 0.7 }) : null;

  function prep(root) {
    (root || document).querySelectorAll('.sf-tech-card__button:not([data-spx-flip])').forEach((btn) => {
      btn.setAttribute('data-spx-flip', '');
      const card = btn.closest('.sf-tech-card');
      const photo = card && card.querySelector('.sf-tech-dialog__image');
      const back = document.createElement('span');
      back.className = 'spx-flip-back';
      back.hidden = true; // tampil otomatis begitu spotec-motion.css termuat
      back.setAttribute('aria-hidden', 'true');
      const frame = document.createElement('span');
      frame.className = 'spx-flip-back__frame';
      if (photo && (photo.getAttribute('src') || photo.getAttribute('srcset'))) {
        const img = document.createElement('img');
        img.alt = '';
        img.loading = 'lazy';
        img.decoding = 'async';
        if (photo.getAttribute('srcset')) {
          img.srcset = photo.getAttribute('srcset');
          img.sizes = '(min-width: 750px) 25vw, 50vw';
        }
        img.src = photo.getAttribute('src') || '';
        frame.appendChild(img);
        // Foto tidak ada (mis. file FEATURE_… belum diupload): coba nama/format lain, lalu logo fitur.
        let alts = (photo.getAttribute('data-srcs') || '').split('|').filter(Boolean);
        const onErr = () => {
          if (alts.length) { img.src = alts.shift(); return; }
          img.removeEventListener('error', onErr);
          img.remove();
          back.classList.add('spx-flip-back--logo');
          const icon = btn.querySelector('.sf-tech-card__icon');
          if (icon && !frame.querySelector('.spx-flip-back__logo')) {
            const logo = icon.cloneNode(true);
            logo.className = 'spx-flip-back__logo';
            logo.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            frame.appendChild(logo);
          }
        };
        img.addEventListener('error', onErr);
      } else {
        // Tidak ada foto: pakai logo teknologi (putih).
        back.classList.add('spx-flip-back--logo');
        const icon = btn.querySelector('.sf-tech-card__icon');
        if (icon) {
          const logo = icon.cloneNode(true);
          logo.className = 'spx-flip-back__logo';
          logo.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
          frame.appendChild(logo);
        }
      }
      back.appendChild(frame);
      const cta = document.createElement('span');
      cta.className = 'spx-flip-back__cta';
      cta.innerHTML = 'View details ' + PLUS;
      back.appendChild(cta);
      btn.appendChild(back);
      if (peekIO && touch.matches && !reduce.matches) peekIO.observe(btn);
    });
  }
  const start = () => {
    prep();
    let timer;
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(prep, 120); })
      .observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

(() => {
  if (window.__spxMotion) return;
  window.__spxMotion = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;

  /* Bagian yang tidak dianimasikan: banner, slider yang bergerak sendiri, header, info produk, panel/popup. */
  const EXCLUDE = [
    '.sf-hero', '.sf-hero-slider', '.sf-slides', 'sf-lineup-glide', 'spotec-activity-loop',
    '.shopify-section-group-header-group', 'header', '.sf-header-section',
    '[data-sf-product-swapped]', '.sf-pdp', '.spx-dr', '.sw-dialog', 'dialog', '.spx-bar'
  ].join(',');

  /* Blok teks / panel: muncul satu per satu. */
  const SINGLE = [
    '.sf-section__heading', '.bend-heading', '.bend-subheading',
    '.sf-features > h2', '.sf-features__subtitle', '.sf-features > .sf-story-body',
    '.sf-brand__copy > *', '.sf-community > *',
    '.spx-plp__head', '.spx-story__panel', '.spx-empty', '.spx-fallback__head',
    '.sc-intro', '.sf-footer__grid > *', '.sf-footer-newsletter > *'
  ];
  /* Grup kartu: muncul berurutan (stagger). */
  const GROUPS = [
    '.sf-product-grid', '.spx-plp-grid', '.sf-category-grid', '.sf-category-track',
    '.sf-tech-grid', '.sc-grid', '.sf-story-gallery', '.sf-features__grid'
  ];
  /* Foto besar: sedikit zoom-out saat muncul (di dalam kotak yang overflow hidden). */
  const MEDIA = ['.sf-brand__image img', '.sf-category > img'];

  const done = new WeakSet();
  const pending = new Set();
  let booted = false;

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      io.unobserve(el);
      pending.delete(el);
      show(el);
    });
  }, { rootMargin: '0px 0px -4% 0px', threshold: 0.01 });

  function show(el) {
    el.classList.add('is-in');
    const delay = parseInt(el.style.getPropertyValue('--spx-delay'), 10) || 0;
    // Setelah selesai, kembalikan ke kondisi asli supaya efek hover bawaan tidak terganggu.
    setTimeout(() => {
      el.removeAttribute('data-spx-reveal');
      el.classList.remove('is-in');
      el.style.removeProperty('--spx-delay');
    }, 1500 + delay);
  }

  function prepare(el, kind, delay) {
    if (done.has(el)) return;
    done.add(el);
    if (el.hidden || el.closest(EXCLUDE)) return;
    const r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return;
    const vh = window.innerHeight;
    const inView = r.top < vh * 0.92 && r.bottom > 0;
    if (!booted && inView) return; // sudah terlihat saat halaman dibuka → biarkan tampil
    el.setAttribute('data-spx-reveal', kind);
    if (delay) el.style.setProperty('--spx-delay', delay + 'ms');
    if (booted && inView) {
      // Konten baru (mis. hasil filter) yang langsung terlihat: animasikan di frame berikutnya.
      requestAnimationFrame(() => requestAnimationFrame(() => show(el)));
    } else {
      pending.add(el);
      io.observe(el);
    }
  }

  function scan(root) {
    const scope = root || document;
    SINGLE.forEach((sel) => scope.querySelectorAll(sel).forEach((el) => prepare(el, 'rise', 0)));
    GROUPS.forEach((sel) => scope.querySelectorAll(sel).forEach((group) => {
      let i = 0;
      [...group.children].forEach((child) => {
        if (done.has(child)) return;
        if (child.hidden) { done.add(child); return; } // kartu tersembunyi ("Load more") punya animasi sendiri
        prepare(child, 'rise', Math.min(i, 5) * 70);
        i += 1;
      });
    }));
    MEDIA.forEach((sel) => scope.querySelectorAll(sel).forEach((el) => prepare(el, 'media', 0)));
  }

  function boot() {
    document.documentElement.classList.add('spx-motion');
    scan();
    booted = true;

    // Konten yang ditambahkan belakangan (filter collection, rekomendasi, dll.).
    let timer;
    new MutationObserver((mutations) => {
      if (!mutations.some((m) => m.addedNodes.length)) return;
      clearTimeout(timer);
      timer = setTimeout(() => scan(), 80);
    }).observe(document.body, { childList: true, subtree: true });

    // Scroll sangat cepat (lompat ke bawah): konten yang terlewati langsung ditampilkan.
    let frame = 0;
    window.addEventListener('scroll', () => {
      if (frame || !pending.size) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const vh = window.innerHeight;
        pending.forEach((el) => {
          if (el.getBoundingClientRect().top < vh) { io.unobserve(el); pending.delete(el); show(el); }
        });
      });
    }, { passive: true });

    // Kembali dari halaman lain (back/forward cache): tampilkan semuanya.
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      document.querySelectorAll('[data-spx-reveal]').forEach((el) => show(el));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();

/* Halaman produk (layar ≥990px): kolom info menempel saat foto digulir. Kalau kolom info lebih tinggi dari layar
   (iPad landscape, laptop), kolom ikut turun dulu sampai bagian bawahnya terlihat, baru menempel —
   jadi tombol & deskripsi di bawah selalu bisa dicapai. */
(() => {
  const wide = matchMedia('(min-width: 990px)');
  const boot = () => {
    const el = document.querySelector('.sf-pdp--catalog .product__info-container');
    if (!el || !('ResizeObserver' in window)) return;
    const HEAD = 100; // sama dengan top:100px di spotec-forge.css
    let frame = 0;
    const fit = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!wide.matches) { el.style.removeProperty('top'); return; }
        const room = window.innerHeight - el.offsetHeight - 16;
        el.style.top = Math.min(HEAD, room) + 'px';
      });
    };
    new ResizeObserver(fit).observe(el);
    window.addEventListener('resize', fit, { passive: true });
    wide.addEventListener?.('change', fit);
    fit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
